import React from "react";
import {
    SearchField as BaseSearchField,
    Button,
    Input,
    Label,
    VisuallyHidden,
    composeRenderProps,
} from "react-aria-components";
import { t } from "ttag";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./search-field.module.scss";

export const SearchField = ({
    children,
    className,
    autoFocus = false,
    ...props
}: React.ComponentProps<typeof BaseSearchField>) => (
    <BaseSearchField
        {...props}
        className={composeRenderProps(className, (cn) =>
            concatClassNames([cn, styles.input]),
        )}
    >
        {composeRenderProps(children, (value) => (
            <>
                <VisuallyHidden>
                    <Label>{t`Search`}</Label>
                </VisuallyHidden>
                <Input
                    autoFocus={autoFocus}
                    placeholder={t`Search`}
                    name="search"
                />
                {value}
                <VisuallyHidden isFocusable>
                    <Button>{t`reset`}</Button>
                </VisuallyHidden>
            </>
        ))}
    </BaseSearchField>
);
